import React from 'react'
import './You_May_Also_Like.css'
import { Swiper, SwiperSlide } from 'swiper/react'
import Product_Info_Card_3 from '../../common_components/product_info_card_3/Product_Info_Card_3'
import { Pagination } from 'swiper/modules'

const You_May_Also_Like = ({data}) => {

   const products = [
        {
            product_name: "Nescafe Classic",
            img: "/assets/images/products/img6.png",
            sub_text: "Price per kg",
            rating: "4.5",
            selling_price: "₹ 120.00",
            mrp: "₹ 150.00",
            discount: "10",
            outOfStock: false,
            company: "Nescafe",
        },

        {
            product_name: "Nescafe Classic",
            img: "/assets/images/products/img6.png",
            sub_text: "Price per kg",
            rating: "4.5",
            selling_price: "₹ 120.00",
            mrp: "₹ 150.00",
            discount: "10",
            outOfStock: true,
            company: "Kellog's",
        },

        {
            product_name: "Nescafe Classic",
            img: "/assets/images/products/img6.png",
            sub_text: "Price per kg",
            rating: "4.5",
            selling_price: "₹ 120.00",
            mrp: "₹ 150.00",
            discount: "10",
            outOfStock: false
        },

        {
            product_name: "Nescafe Classic",
            img: "/assets/images/products/img6.png",
            sub_text: "Price per kg",
            rating: "4.5",
            selling_price: "₹ 120.00",
            mrp: "₹ 150.00",
            discount: "10",
            outOfStock: false
        },

        {
            product_name: "Nescafe Classic",
            img: "/assets/images/products/img6.png",
            sub_text: "Price per kg",
            rating: "4.5",
            selling_price: "₹ 120.00",
            mrp: "₹ 150.00",
            discount: "10",
            outOfStock: false
        },

        {
            product_name: "Nescafe Classic",
            img: "/assets/images/products/img6.png",
            sub_text: "Price per kg",
            rating: "4.5",
            selling_price: "₹ 120.00",
            mrp: "₹ 150.00",
            discount: "10",
            outOfStock: false
        },

        {
            product_name: "Nescafe Classic",
            img: "/assets/images/products/img6.png",
            sub_text: "Price per kg",
            rating: "4.5",
            selling_price: "₹ 120.00",
            mrp: "₹ 150.00",
            discount: "10",
            outOfStock: false
        },

        {
            product_name: "Nescafe Classic",
            img: "/assets/images/products/img6.png",
            sub_text: "Price per kg",
            rating: "4.5",
            selling_price: "₹ 120.00",
            mrp: "₹ 150.00",
            discount: "10",
            outOfStock: false
        },

    ]

  return (
    <section className='You_May_Also_Like'>

    <p className='section_title'>You may also like</p>

      <div className='main_swiper_div'>
        <Swiper
          spaceBetween={15}
          pagination={{
            dynamicBullets: true,
            clickable: true
          }}
          modules={[Pagination]}
          autoplay={{ delay: 300 }}
          className="common_swiper"
          breakpoints={{
            0: {
              slidesPerView: 1.2,
            },
            380: {
              slidesPerView: 1.5,
            },
            480: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 3,
            },
            768: {
              slidesPerView: 3,
            },
            992: {
              slidesPerView: 3.5,
            },
            1200: {
              slidesPerView: 4,
            },
            1400: {
              slidesPerView: 5,
            },

          }}
        >
          {data?.map((val) => {
            return (
              <SwiperSlide >
                <Product_Info_Card_3 product={val} showQty />
              </SwiperSlide>
            )
          })}

        </Swiper>

      </div>
    </section>
  )
}

export default You_May_Also_Like
